<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <p>Выберите страницу из меню слева.</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Dashboard",
  components: {},
  data: () => ({
    Dummy: null
  })
};
</script>
